//check wheather plan is paid or [free forever/trial] unpaid

import {
  BILLING_PLAN_FREE_FOREVER,
  BILLING_SUBSCRIBED_PLAN_STATUS_TRIAL,
} from "../_components/details/constants";

export const isFreePlan = (subscription) => {
  return (
    subscription?.status === BILLING_SUBSCRIBED_PLAN_STATUS_TRIAL ||
    subscription?.plan?.product?.name === BILLING_PLAN_FREE_FOREVER
  );
};

// true if  trial ended or free freeforever
export const isFreePlanOrTrialEnded = (subscribedPlan) => {
  return (
    (subscribedPlan?.trial_remaining_days === null &&
      subscribedPlan?.plan?.product?.name === BILLING_PLAN_FREE_FOREVER) ||
    (subscribedPlan?.trial_remaining_days !== null &&
      subscribedPlan?.trial_remaining_days <= 0)
  );
};
